import { AppDispatch } from '@app/model/store/client'
import { setNews, setOthersNewsList, setRestaurantsList } from '@pages/NewsItem/model/slice'
import { API } from '@shared/api'
import { isRestaurantReadSlug } from '@shared/api/middleware/mappingAPI/restaurant/isRestaurantReadSlug'
import type { TypeMappingNewsOutput } from '@shared/api/middleware/mappingAPI/news/type'
import type { TypeMappingRestOutput } from '@shared/api/middleware/mappingAPI/restaurant/type'

type InitNewsItemPayload = {
  news: TypeMappingNewsOutput
  other_news: TypeMappingNewsOutput[]
  restaurants?: TypeMappingRestOutput[] | null
}

export const initNewsItem = (data: InitNewsItemPayload) => async (dispatch: AppDispatch) => {
  dispatch(setNews(data.news))
  dispatch(setOthersNewsList(data.other_news))

  if (data.restaurants?.length) {
    dispatch(setRestaurantsList(data.restaurants))
    return
  }

  const restaurantsList = data.news.restaurants ?? []
  const restaurantsRequests = restaurantsList
    .filter((rest) => isRestaurantReadSlug(rest.url.slug))
    .map((rest) => API.restaurant_read({ path: rest.url.slug }))
  const restaurants = await Promise.all(restaurantsRequests).catch((): null => {
    console.error('Ошибка загрузки данных')
    return null
  })
  dispatch(setRestaurantsList(restaurants ?? []))
}
